import styled from 'styled-components';

import { theme } from '../../theme';
import { baseTextStyles, finePrintStyles, headingStyles } from './text.styles';
import { ColorVariantEnum, IFinePrint, IHeading, ILink, IText } from './text.types';

const Heading = styled.h1<IHeading>`
	${baseTextStyles};
	font-family: ${theme.typography.fonts.semibold};
	${(props) => headingStyles[props.size]};
	line-height: ${(props) => props.noLineHeight && '100%'};
`;

const Title = styled.h2<IText>`
	${baseTextStyles};
	font-family: ${theme.typography.fonts.semibold};
	font-size: 22px;
	line-height: 26px;
	line-height: ${(props) => props.noLineHeight && '100%'};
`;

const SubTitle = styled.h3<IText>`
	${baseTextStyles};
	font-family: ${theme.typography.fonts.semibold};
	font-size: 17px;
	line-height: 22px;
	line-height: ${(props) => props.noLineHeight && '100%'};
`;

const Paragraph = styled.p<IText>`
	${baseTextStyles};
	font-size: 15px;
	line-height: 24px;
	line-height: ${(props) => props.noLineHeight && '100%'};
`;

const FinePrint = styled.p<IFinePrint>`
	${baseTextStyles};
	${(props) => finePrintStyles[props.type]};
	line-height: ${(props) => props.noLineHeight && '100%'};
`;

const Link = styled.a<ILink>`
	color: ${(props) =>
		props.colorVariant ? theme.colors.text[props.colorVariant] : theme.colors.text[ColorVariantEnum.INFO]};
	text-decoration: underline;
	cursor: pointer;
`;

export const Text = {
	Heading,
	Title,
	SubTitle,
	Paragraph,
	FinePrint,
	Link,
};
